import React from 'react'
import { useDispatch, batch } from 'react-redux'
import { useAccommodationOrder, setAccommodationOrder } from '../slices/accommodation'
import { showSidebar } from '../slices/ui'
import {
  ACCOMMODATION_ORDER,
  RELEVANCE,
  CHEAPEST,
  RATING,
  ONLINE_BOOKABLE,
  DISABLED_FRIENDLY,
  PET_FRIENDLY,
  AVERAGE_PRICE,
  LUXURY
} from '../trans'

const AccommodationsOrderControl = () => {

  const order = useAccommodationOrder()
  const dispatch = useDispatch() 

  const onChangeHandler = (e) =>  {
    window.scrollTo(0, 0)
    batch(()=>{
      dispatch(setAccommodationOrder(e.target.value))
      dispatch(showSidebar(null))
    })
  }

  return (
    <form>

      <fieldset className="sidebar__fieldset">

        <legend>{ACCOMMODATION_ORDER}</legend>

        <label className="sidebar__radio">
          {RELEVANCE} 
          <input
            type="radio"
            name="accommodationOrder"
            value="relevance"
            checked={order == 'relevance'}
            onChange={onChangeHandler}
          />
        </label>
        <label className="sidebar__radio">
          {CHEAPEST}
          <input
            type="radio"
            name="accommodationOrder"
            value="cost-1"
            checked={order == 'cost-1'}
            onChange={onChangeHandler}
          />
        </label>
        <label className="sidebar__radio">
          {RATING}
          <input
            type="radio"
            name="accommodationOrder"
            value="rating"
            checked={order == 'rating'}
            onChange={onChangeHandler}
          />
        </label>

        <label className="sidebar__radio">
          {ONLINE_BOOKABLE}
          <input
            type="radio"
            name="accommodationOrder"
            value="bookable"
            checked={order == 'bookable'}
            onChange={onChangeHandler}
          />
        </label>

        <label className="sidebar__radio">
          {DISABLED_FRIENDLY}
          <input
            type="radio"
            name="accommodationOrder"
            value="accessibility"
            checked={order == 'accessibility'}
            onChange={onChangeHandler}
          />
        </label>

        <label className="sidebar__radio">
          {PET_FRIENDLY}
          <input
            type="radio"
            name="accommodationOrder"
            value="pets_allowed"
            checked={order == 'pets_allowed'}
            onChange={onChangeHandler}
          />
        </label>

        <label className="sidebar__radio">
          {AVERAGE_PRICE}
          <input
            type="radio"
            name="accommodationOrder"
            value="cost-2"
            checked={order == 'cost-2'}
            onChange={onChangeHandler}
          />
        </label>

        <label className="sidebar__radio">
          {LUXURY}
          <input
            type="radio"
            name="accommodationOrder"
            value="cost-3"
            checked={order == 'cost-3'}
            onChange={onChangeHandler}
          />
        </label>
      </fieldset>
    </form> 
  )

}

export default AccommodationsOrderControl

